import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { NdtHubBase } from '../base/ndt-hub.base';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { mailboxMessageChanged } from './currently-viewing-mailbox-message-register-hub.actions';

@Injectable({ providedIn: 'root' })
export class CurrentlyViewingMailboxMessagesRegisterHub extends NdtHubBase {

   constructor(public ndtHubService: NdtHubConnectionService, private store: Store) {
      super(ndtHubService);
   }

   registerAsViewingMailboxMessagesRegister(mailboxId: number | null): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinCurrentlyViewingMailboxMessagesRegister', mailboxId);
      });
   }

   unregisterAsViewingMailboxMessagesRegister(mailboxId: number | null): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('LeaveCurrentlyViewingMailboxMessagesRegister', mailboxId);
      });
   }

   wireUpHubEvents(): void {
      this.ndtHubService.connection.on('MailboxMessageChanged', () => {
         this.store.dispatch(mailboxMessageChanged());
      });
   }
}
